export default "__VITE_ASSET__DSKjyCu1__"